import * as React from 'react'
import _ from 'lodash'
import { useParams, useSearchParams } from 'react-router-dom'
import { useCampaignCardBySlugOrIdQuery } from '/~/types/graphql'
import { CampaignCard, CampaignCardWrapper } from '/~/components/Cards'
import { normalizeSingleNewApiCampaignCard, normalizeSingleOldApiCampaignCard } from '/~/utils/campaignCard'
import { useGetPublishedCampaignCardByAliasQuery } from '/~/types/issuer-graphql'
import { client } from '/~/lib/issuer-client/client'
import { Caption } from '/fiweb/components'
import { Paragraph } from 'evergreen-ui'

const EmbeddedCampaignCardPage = () => {
  const { campaignSlug } = useParams<{ campaignSlug: string }>()
  const { data, loading } = useCampaignCardBySlugOrIdQuery({ variables: { slug: campaignSlug } })
  const { data: issuerApiData, loading: issuerApiLoading } = useGetPublishedCampaignCardByAliasQuery({
    variables: { alias: campaignSlug },
    client,
    skip: !client,
  })
  const [searchParams] = useSearchParams()
  const isCardDataCrawler = searchParams.get('show-closing-time') === 'true'

  const domainLink = (
    <Caption
      align='center'
      is='a'
      textDecoration='none'
      href={window.location.origin}
      target='_blank'
      style={{ color: 'inherit' }}
    >
      <b>FOLKEINVEST.NO</b>
    </Caption>
  )

  if (loading || issuerApiLoading) {
    return null
  }
  const oldCardData = data?.campaignCardBySlugOrId
  const issuerCardData = issuerApiData?.publishedCampaignCardByAlias

  if (!(issuerCardData || oldCardData)) {
    return (
      <div
        style={{
          padding: 10,
          display: 'flex',
          flexFlow: 'column',
          alignItems: 'center',
        }}
      >
        <Paragraph>Fant ikke emisjonskort på dette navnet:</Paragraph>
        <Caption align='center'>{campaignSlug}</Caption>
        <Paragraph>Er du sikker på at dette stemmer?</Paragraph>
        {domainLink}
      </div>
    )
  }
  const cardData = issuerCardData
    ? normalizeSingleNewApiCampaignCard(issuerCardData)
    : normalizeSingleOldApiCampaignCard(oldCardData)

  return (
    <div
      style={{
        padding: 10,
        display: 'flex',
        flexFlow: 'column',
        alignItems: 'center',
      }}
    >
      <CampaignCardWrapper>
        <CampaignCard card={cardData} displayForMarketingEmail={isCardDataCrawler} />
      </CampaignCardWrapper>
      {domainLink}
    </div>
  )
}

export default EmbeddedCampaignCardPage
